import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { QuitInfoState } from '@/mobile/states/mobileQuitInfoState';
import { formatDate } from '@/utils/commonFunc';
import collectionHopeDateState from '@/mobile/states/collectionHopeDateState';
import { CollectionHopeDateType } from '@/mobile/types/api/mypage/collectionHopeDate';

type CollectionHopeDateProps = UseFormReturn<CollectionHopeDateType>;

/**
 * レンタルWiFi返却時の集荷希望日時入力を担当する共通部品。
 * @param props react-hook-form の登録情報
 * @returns 集荷希望日・時間帯入力コンポーネント
 */
const CollectionHopeDate = ({ register }: CollectionHopeDateProps) => {
  const setCollectionHopeDateState = useSetRecoilState(collectionHopeDateState);
  const quitInfo = useRecoilValue(QuitInfoState);
  const { collectionHopeDate, collectionHopeTimezone } = useRecoilValue(collectionHopeDateState);

  // API が返した候補の先頭を初期値にし、未選択のまま送信される状態を避ける。
  const firstDate = quitInfo.collection_hope_date ? quitInfo.collection_hope_date[0].key : '';
  const firstTimezone = quitInfo.collection_hope_timezone
    ? quitInfo.collection_hope_timezone[0].key
    : '';

  useEffect(() => {
    // 画面再訪時に Recoil 側の保持値があればそれを優先し、なければ候補先頭を採用する。
    if (!collectionHopeDate) {
      setCollectionHopeDateState({
        collectionHopeDate: firstDate,
        collectionHopeTimezone: firstTimezone,
      });
    }
  });

  return (
    <>
      <div>
        <h3>■&nbsp;&nbsp;集荷希望指定日</h3>
        <br />
      </div>
      <div>
        <table>
          <colgroup>
            <col width='35%' />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th style={{ paddingBottom: '20px', textAlign: 'left' }}>集荷希望日</th>
              <td>
                <label className='m-form__lytItem'>
                  <select
                    defaultValue={collectionHopeDate || firstDate}
                    {...register('collectionHopeDate', {
                      onChange: (e) => {
                        // 確認画面へ戻ったあとも選択を維持できるよう、Recoil に同期しておく。
                        if (e.target.value) {
                          setCollectionHopeDateState((prev) => ({
                            ...prev,
                            collectionHopeDate: e.target.value,
                          }));
                        }
                      },
                    })}
                  >
                    {quitInfo.collection_hope_date?.map(({ key, value }) => (
                      <option key={key} value={key}>
                        {formatDate(value)}
                      </option>
                    ))}
                  </select>
                </label>
              </td>
            </tr>
            <tr>
              <th
                rowSpan={quitInfo.collection_hope_timezone?.length}
                style={{ textAlign: 'left', verticalAlign: 'top' }}
              >
                集荷希望時間帯
              </th>
              <td>
                <ul>
                  {quitInfo.collection_hope_timezone?.map(({ key, value }) => (
                    <li key={key}>
                      <label key={key}>
                        <input
                          type='radio'
                          value={key}
                          checked={key === collectionHopeTimezone}
                          style={{ marginRight: '10px' }}
                          {...register('collectionHopeTimezone', {
                            onChange: (e) => {
                              // 日付と同様に時間帯も状態保持し、再入力の手間を減らす。
                              if (e.target.value) {
                                setCollectionHopeDateState((prev) => ({
                                  ...prev,
                                  collectionHopeTimezone: e.target.value,
                                }));
                              }
                            },
                          })}
                        />
                        {value}
                      </label>
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CollectionHopeDate;
